/*!
 *
 *	megamenu.js
 *
 */

module.exports = function(){
	$('#global > ul > li').on('mouseenter', function(){
		$(this).children('.global_second_wrapper').fadeIn(300);
	}).on('mouseleave', function(){
		$(this).children('.global_second_wrapper').fadeOut(300);
	});

	$('.global_second li a').on('tap', function(e){
		e.preventDefault();
		if( $(this).is('.active') ) return false;
		var $target = $( $(this).attr('rel') );
		$('.global_second li a.active, .global_third.active').removeClass('active');
		$(this).addClass('active');
		$target.addClass('active');
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/megamenu.js
// module id = 21
// module chunks = 0